import React, {useState, useEffect} from "react";
import {connect} from "react-redux";
import {useTranslation} from "react-i18next";
import get from 'lodash/get';
import {
    IonPage,
    IonContent,
    IonLoading,
    IonThumbnail,
    IonImg,
    IonLabel
} from '@ionic/react';
import CommonHeader from '../../Components/CommonHeader';
import WrapperIonInput from "../../Components/ionic/WrapperIonInput";
import WrapperIonButton from "../../Components/ionic/WrapperIonButton";
import {updateNameShopAdministrator, updateAvatar} from "../../thunks/Settings";
import {touchUpdateNameShopAdministratorForm} from "../../actions/Shops";
import {postRequestDjango} from "../../requests";
import {getPhotoFromGallery} from "../../Components/utils";

const PersonalSettings = (
    {
        currentShopAdministrator,
        updateNameShopAdministrator,
        touchUpdateNameShopAdministratorForm,
        errors,

        updateAvatar,
    }
) => {
    const {t} = useTranslation();

    const [userData, setUserData] = useState(null);
    const [urlAvatar, setUrlAvatar] = useState(null);
    const [ionloading, setIonloading] = useState(false);

    useEffect(() => {
        if (currentShopAdministrator) {
            setUserData(currentShopAdministrator.profile.user);
            setUrlAvatar(currentShopAdministrator.profile.avatar_url);
        }
    }, [currentShopAdministrator]);

    const sendPersonalSettingsRequest = (e) => {
        e.preventDefault();
        setIonloading(true);
        updateNameShopAdministrator(userData.username, () => {
            setIonloading(false);
        });
    }

    const getPhotoAndSendIt = async () => {
        let result = await getPhotoFromGallery();
        if (result) {
            setIonloading(true);
            let filename = new Date().getTime() + '.jpg';
            let formData = new FormData();
            formData.append("file", result, filename);

            postRequestDjango(`/cdn/upload/${filename}/`, formData, {timeout: 30000}).then(
                ({data}) => {
                    updateAvatar(data.result.cdn_filepath, () => {
                        setUrlAvatar(data.result.cdn_filepath);
                    },
                    () => {
                        setIonloading(false);
                    });
                },
                () => {
                    setUrlAvatar(null);
                    setIonloading(false);
                },
            );
        }
    }

    return <>
        <IonPage>
            <CommonHeader title={t('menu.personal_settings', "Personal settings")} />
            <IonContent className="ion-padding">
                {userData && <>
                    <div className="i-personal-settings">
                        <IonLabel mode="ios" className="i-label i-label_black i-personal-settings__label">
                            {t('settings.personal_settings.avatar', "Avatar")}
                        </IonLabel>
                        <IonThumbnail className="i-personal-settings__avatar" onClick={() => getPhotoAndSendIt()}>
                            {urlAvatar ? <IonImg src={urlAvatar} alt="Avatar" /> : get(currentShopAdministrator, 'profile.user.username')[0].toUpperCase()}
                        </IonThumbnail>
                        <p className="i-personal-settings__prompt">{t('settings.personal_settings.prompt')}</p>
                    </div>
                    <form onSubmit={sendPersonalSettingsRequest} autoComplete="on">
                        <WrapperIonInput
                            label={`${t('settings.personal_settings.username', "Username (must be unique)")} *`}
                            value={userData.username}
                            Change={(value) => setUserData({...userData, username: value})}
                            Click={touchUpdateNameShopAdministratorForm}
                            required={true}
                            error={get(errors, 'username')}
                            info={get(errors, 'username')}
                        />
                        <WrapperIonButton
                            type="submit"
                            title={t('settings.personal_settings.button_save', "Save")}
                            disabled={userData.username === ''}
                        />
                    </form>
                </>}
                <IonLoading
                    mode="ios"
                    isOpen={ionloading}
                    message={'Please wait...'}
                />
            </IonContent>
        </IonPage>
    </>
}

const mapStateToProps = state => ({
    currentShopAdministrator: state.Shops.currentShopAdministrator,
    errors: state.Shops.updateNameShopAdministratorError
});

const mapDispatchToProps = dispatch => ({
    updateNameShopAdministrator: (data, callback) => dispatch(updateNameShopAdministrator(data, callback)),
    touchUpdateNameShopAdministratorForm: () => dispatch(touchUpdateNameShopAdministratorForm()),
    updateAvatar: (avatar_url, callbackSuccess, callback) => dispatch(updateAvatar(avatar_url, callbackSuccess, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PersonalSettings);
